import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService, UiLanguage } from '../../core/language.service';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
  imports: [
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    AsyncPipe,
    TranslateModule,
  ],
})
export class LanguageSelectComponent {
  public get currentLanguage(): Observable<UiLanguage> {
    return this.languageService.currentLanguage.asObservable();
  }

  public get supportedLanguages(): UiLanguage[] {
    return this.languageService.supportedLanguages;
  }

  constructor(private languageService: LanguageService) {}

  onLanguageSelect(selectedLanguage: UiLanguage) {
    this.languageService.use(selectedLanguage.lang);
  }
}
